import { mapActions } from 'vuex'

export default {
  mounted () {
    this.checkAndJumpBindCard()
  },
  methods: {
    ...mapActions('bankcard', ['jumpBindCardPageX']),

    async checkAndJumpBindCard () {
      try {
        const res = await this.jumpBindCardPageX()
        if (res.success && res.data.needJump === 'Y') {
          this.$router.push({
            path: '/bankcard/add',
            query: {
              bankcardNo: res.data.bankCardNo,
              loanPlatform: 'TMD',
              fundCode: 'NDMICRO',
              productCd: 'TMDP'
            }
          })
          return true
        }
        return false
      } catch (e) {
        return false
      }
    }
  }
}
